import React from "react";
import assign from "lodash/assign";
import set from "lodash/set";
import isEqual from "lodash/isEqual";
import { RaisedButton, TextField, CircularProgress } from "material-ui";
import { Link } from "react-router";
import Helmet from "react-helmet";

const PASSWORD_PLACEHOLDER = "•••••••••";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";

import Label from "./partials/label.jsx";
import LinkLike from "./partials/link-like.jsx";
import PhoneField from "./partials/phone-field.jsx";
import MailingListPreferenceField from "./partials/mailing-list-preference-field.jsx";

@connectToStores
class AccountManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      person: null,
      dirty: false,
      editingPassword: false,
      values: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.save = this.save.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object,
      tenant: React.PropTypes.object
    };
  }

  static componentDidConnect(props, context) {
    if (!PersonStore.isLoggedIn()) {
      context.router.replace({
        pathname: "/login",
        query: { next: "/account" },
        state: {}
      });
    }
  }

  getStyles() {
    return {
      actions: {
        marginTop: 30
      },
      container: {
        padding: 10,
        textAlign: "center"
      },
      subcontainer: {
        fontSize: 14,
        margin: "17px auto",
        textAlign: "left",
        maxWidth: 256,
        lineHeight: 1.3
      },
      subActions: {
        marginTop: 3
      },
      error: {
        color: "#FF4136"
      },
      bodyWrapper: {
        maxWidth: 600,
        margin: "0 auto"
      },
      bodyInner: {
        display: "inline-block",
        width: "50%",
        minWidth: 300,
        verticalAlign: "top"
      }
    };
  }

  clearPaymentInfo() {
    if (
      window.confirm(
        "Are you sure you'd like to remove your saved payment information?"
      )
    ) {
      PersonActions.edit({
        clear_payments_info: true
      });
    }
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined" ? !checked : e.target.value
    );
  }

  onChangeValue(id, value) {
    var values = assign({}, this.state.values);
    set(values, id, value);
    this.setState({
      dirty: true,
      values: values
    });
  }

  save() {
    var values = assign({}, this.state.values);
    this.setState({ dirty: false }, () => {
      PersonActions.edit(values);
    });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
    PersonActions.clearErrors.defer();
  }

  componentWillReceiveProps(newProps) {
    var person = newProps.details;

    if (person) {
      person.password = "";
    }

    this.setState({
      person,
      values: this.state.dirty
        ? Object.assign({}, person, this.state.values)
        : Object.assign({}, person)
    });

    if (this.props.isLoggedIn && !newProps.isLoggedIn) {
      this.context.router.push("/");
    }
  }

  render() {
    var styles = this.getStyles();

    if (
      !PersonStore.isLoggedIn() ||
      !this.state.person ||
      this.props.editInProgress
    ) {
      return (
        <div style={styles.container}>
          <Helmet title="Account" />
          <CircularProgress
            mode="indeterminate"
            size={119}
            thickness={7}
            style={{ margin: 20 }}
          />
        </div>
      );
    }

    const isSundance = !!this.state.person.sundance_user_id;
    const isCannes = !!this.state.person.cannes_accreditation_id;

    return (
      <div>
        <Helmet title="Account" />
        {this.props.children
          ? React.cloneElement(this.props.children, {
              appSettings: this.props.appSettings
            })
          : undefined}
        <form autoComplete="off" style={styles.container}>
          <h2>Account management</h2>
          {isSundance || isCannes ? null : (
            <div style={{ maxWidth: 350, margin: "0 auto 10px" }}>
              Manage your Eventive account. The settings you change here will be
              reflected across all Eventive-powered sites.
            </div>
          )}
          <div style={styles.bodyWrapper}>
            <div style={styles.bodyInner}>
              <div>
                <TextField
                  value={this.state.values.name}
                  floatingLabelText="Name"
                  floatingLabelFixed={true}
                  onChange={e => this.onChangeValue("name", e.target.value)}
                  disabled={isSundance || isCannes}
                />
              </div>
              <div>
                <TextField
                  value={this.state.values.email}
                  floatingLabelText="Email address"
                  floatingLabelFixed={true}
                  autoComplete="username email"
                  onChange={e => this.onChangeValue("email", e.target.value)}
                  disabled={isSundance || isCannes}
                />
              </div>
              <div>
                <PhoneField
                  value={this.state.values.phone_number}
                  floatingLabelText="Phone number"
                  floatingLabelFixed={true}
                  autoComplete="phone"
                  hintText={"(123) 456-7890"}
                  onChange={e =>
                    this.onChangeValue("phone_number", e.target.value)
                  }
                />
              </div>
              {this.state.person.legal_name ? (
                <div>
                  <TextField
                    value={this.state.values.legal_name}
                    floatingLabelText="Full legal name (for donations)"
                    floatingLabelFixed={true}
                    onChange={e =>
                      this.onChangeValue("legal_name", e.target.value)
                    }
                  />
                </div>
              ) : null}
              {isSundance || isCannes ? null : (
                <div>
                  <TextField
                    style={{ textAlign: "left" }}
                    floatingLabelText="Mailing address"
                    floatingLabelFixed={true}
                    hintText={
                      <div style={{ textAlign: "left" }}>
                        123 Main Street
                        <br />
                        New York, NY 10001
                      </div>
                    }
                    multiLine={true}
                    value={this.state.values.mailing_address}
                    rows={2}
                    rowsMax={2}
                    onChange={e =>
                      this.onChangeValue("mailing_address", e.target.value)
                    }
                  />
                </div>
              )}
            </div>
            <div style={styles.bodyInner}>
              {this.state.editingPassword ? (
                <TextField
                  value={this.state.values.password}
                  type="password"
                  floatingLabelText="Password"
                  floatingLabelFixed={true}
                  autoComplete="new-password"
                  hintText={PASSWORD_PLACEHOLDER}
                  onChange={e => this.onChangeValue("password", e.target.value)}
                />
              ) : (
                <div style={styles.subcontainer}>
                  <Label>Password</Label>
                  {isSundance ? (
                    <div>No password &ndash; logged in via Sundance</div>
                  ) : isCannes ? (
                    <div>No password &ndash; logged in via Cannes</div>
                  ) : this.state.person.eventival_person_id ? (
                    <div>No password &ndash; logged in via Eventival</div>
                  ) : this.state.person.ida_user_id ? (
                    <div>No password &ndash; logged in via MyIDA</div>
                  ) : (
                    <RaisedButton
                      label={"Change password"}
                      primary={false}
                      onClick={() => this.setState({ editingPassword: true })}
                    />
                  )}
                </div>
              )}
              <div style={styles.subcontainer}>
                <Label>Saved payment method</Label>
                <div>
                  {this.state.person.payment_method_summary ||
                    "No saved payment method"}
                </div>
                {this.state.person.payment_method_summary ? (
                  <div style={styles.subActions}>
                    <Link to="/account/payment">Edit payment method</Link> ·{" "}
                    <LinkLike onClick={this.clearPaymentInfo}>Remove</LinkLike>
                  </div>
                ) : (
                  <div style={styles.subActions}>
                    <Link to="/account/payment">Add payment method</Link>
                  </div>
                )}
              </div>
              <div style={styles.subcontainer}>
                <Label>Cookie preferences</Label>
                <RaisedButton
                  label={"Manage cookie preferences"}
                  primary={false}
                  onClick={() => { window.CookieConsent.showPreferences(); }}
                />
              </div>
              {this.state.person.facebook_connected ? (
                <div style={styles.subcontainer}>
                  <Label>Facebook status</Label>
                  <div>Connected</div>
                </div>
              ) : null}
              {this.state.person.eventival_person_id ? (
                <div style={styles.subcontainer}>
                  <Label>Eventival status</Label>
                  <div>Connected</div>
                </div>
              ) : null}
              {this.state.person.ida_user_id ? (
                <div style={styles.subcontainer}>
                  <Label>MyIDA status</Label>
                  <div>Connected</div>
                </div>
              ) : null}
              {this.state.person.sundance_user_id ? (
                <div style={styles.subcontainer}>
                  <Label>Sundance status</Label>
                  <div>Connected</div>
                </div>
              ) : null}
              {isCannes ? (
                <div style={styles.subcontainer}>
                  <Label>Cannes status</Label>
                  <div>Connected</div>
                </div>
              ) : null}
              {this.context.tenant.hide_account_communication_preferences ||
              isSundance || isCannes ? null : (
                <div style={styles.subcontainer}>
                  <Label>Communication preferences</Label>
                  <MailingListPreferenceField
                    value={!this.state.values.do_not_email}
                    onChange={v => this.onChangeValue("do_not_email", !v)}
                    style={{
                      border: "1px solid #ccc",
                      padding: "10px 4px 10px 16px",
                      width: 256,
                      boxSizing: "border-box"
                    }}
                  />
                </div>
              )}

            </div>
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label={this.state.dirty ? "Save changes" : "No changes to save"}
              primary={true}
              disabled={!this.state.dirty}
              onClick={this.save}
            />
          </div>
          {this.props.editErrorMessage ? (
            <p style={styles.error}>
              Error updating account: {this.props.editErrorMessage}
            </p>
          ) : null}
        </form>
      </div>
    );
  }
}

export default AccountManagement;



// WEBPACK FOOTER //
// ./src/app/components/account.jsx